export const UserEndpoints = {
  getLoggedInUserInfo: process.env['NEXT_PUBLIC_API'] + '/users/me',
  updateUserInfo: process.env['NEXT_PUBLIC_API'] + '/users/me',
  getMyRanks: process.env['NEXT_PUBLIC_API'] + '/users/me/ranks',
  getMyStats: process.env['NEXT_PUBLIC_API'] + '/users/me/stats',
  getMyCoinsCount: process.env['NEXT_PUBLIC_API'] + '/users/me/balance',
  getAvatars: process.env['NEXT_PUBLIC_API'] + '/users/me/avatars',
  changeAvatar: process.env['NEXT_PUBLIC_API'] + '/users/me/photo',
  changePassword: process.env['NEXT_PUBLIC_API'] + '/users/me/password',
  getMyBalance: process.env['NEXT_PUBLIC_API'] + '/users/me/balance',
  getCountriesList: process.env['NEXT_PUBLIC_API'] + '/countries',
  getBalance: process.env['NEXT_PUBLIC_API'] + '/teachers/balance',
  checkUser: process.env['NEXT_PUBLIC_API']+'/users/check'
};
